﻿import React, { useEffect } from 'react';

// ==============================|| NAVIGATION - SCROLL TO TOP ||============================== //

interface ScrollTopProps {
  children?: React.ReactNode;
}

export default function ScrollTop({ children }: ScrollTopProps) {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }, []);

  return children || null;
}

// Removed legacy propTypes

